import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon InvoicesIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const InvoicesIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g>
        <path d="M41.4,19c-0.3,0-0.6,0-1.1,0c-0.6,0-2.4,0-5.4,0c-5,0-11.8,0-12,0c-0.6,0-0.7,0.2-0.7,0.2 c-0.1,0.2-0.2,0.4-0.2,0.6v30.4c0,0.2,0,0.4,0.1,0.5s0.5,0.2,0.8,0.3H47c0.6,0,0.7-0.2,0.8-0.3c0.1-0.2,0.2-0.4,0.2-0.6 c0-1,0-24.5,0-25.3c0-0.1,0-0.2,0-0.3C45.3,22.2,42.4,19.7,41.4,19C41.5,19,41.5,19,41.4,19z M41.4,17c0.7,0,0.7,0,1,0.2 s7.2,6.1,7.2,6.1c0.4,0.3,0.4,0.8,0.4,1.6s0,25.3,0,25.3c0,1-0.6,2.8-2.9,2.8H22.9c-1.3,0-3-0.7-2.9-2.8V19.9c0-1,0.6-2.8,2.9-2.8 c0,0,15.4,0,17.4,0C40.8,17,41.2,17,41.4,17z" />
      </g>
      <g>
        <path d="M49,25.5c-0.01,0-0.02,0-0.03,0l-7.9-0.2l0,0c-1.35,0-2-0.56-2.17-1.88c0-0.04-0.01-0.08-0.01-0.12V18 c0-0.55,0.45-1,1-1c0.63,0,1.28,0,1.96,0.11c0.14,0.02,0.27,0.08,0.39,0.15c0.19,0.13,0.95,0.77,3.84,3.28 c0.93,0.81,1.72,1.5,1.95,1.68c0.63,0.53,1.16,1.05,1.67,1.56c0.29,0.29,0.37,0.73,0.21,1.1C49.76,25.26,49.4,25.5,49,25.5z M40.91,23.29c0.05,0,0.11,0,0.19,0l5.27,0.13c-0.38-0.32-0.95-0.82-1.58-1.37c-1.19-1.03-2.92-2.53-3.49-3.01 c-0.13-0.01-0.26-0.03-0.39-0.03v4.22C40.9,23.26,40.91,23.28,40.91,23.29z" />
      </g>
      <g>
        <path d="M35.9,28.8h-11c-0.55,0-1-0.45-1-1s0.45-1,1-1h11c0.55,0,1,0.45,1,1S36.45,28.8,35.9,28.8z" />
      </g>
      <g>
        <path d="M35.9,23.8h-11c-0.55,0-1-0.45-1-1s0.45-1,1-1h11c0.55,0,1,0.45,1,1S36.45,23.8,35.9,23.8z" />
      </g>
      <g>
        <path d="M35.3,45.78c-0.34,0-0.68-0.03-0.99-0.09c-0.61-0.12-1.23-0.37-1.82-0.72c-0.71-0.42-1.11-0.99-1.44-1.54 c-0.28-0.47-0.13-1.09,0.34-1.37s1.09-0.13,1.37,0.34c0.28,0.46,0.48,0.69,0.76,0.86c0.4,0.24,0.8,0.4,1.18,0.48 c0.37,0.07,0.83,0.07,1.21,0c0.45-0.09,0.88-0.25,1.09-0.42c0.52-0.38,0.74-0.96,0.56-1.47c-0.25-0.73-1.24-1.18-2.53-1.13 c-2.44,0.12-3.74-1.25-3.92-2.68c-0.19-1.46,0.76-3.25,2.89-3.7c0.93-0.23,1.91-0.23,2.78,0.02c0.88,0.22,1.67,0.75,2.39,1.62 c0.35,0.42,0.3,1.05-0.13,1.41s-1.06,0.3-1.41-0.13c-0.45-0.54-0.89-0.85-1.38-0.97c-0.57-0.16-1.18-0.16-1.81,0 c-0.99,0.21-1.43,0.92-1.35,1.49c0.08,0.65,0.79,1.01,1.86,0.94c2.28-0.03,3.95,0.87,4.5,2.48c0.46,1.34-0.05,2.83-1.26,3.72 c-0.62,0.47-1.45,0.69-1.9,0.78C35.98,45.74,35.64,45.78,35.3,45.78z" />
      </g>
      <g>
        <path d="M35.2,35c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1s1,0.45,1,1v2C36.2,34.55,35.75,35,35.2,35z" />
      </g>
      <g>
        <path d="M35.2,48.3c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1s1,0.45,1,1v2C36.2,47.85,35.75,48.3,35.2,48.3z" />
      </g>
    </Icon>
  )
}
export default InvoicesIcon
